import React from 'react';
import { connect } from 'react-redux';
import {Grid, Row, Col} from 'react-bootstrap';
import {translate} from '../../i18n/translate.js';
import {JoinSteps, FetchingTypes, JoinModes} from '../../common/constants.js';
import JoinItemCard from "./JoinItemCard.js";
import {isFetching} from "../../actions/common/fetchingActions";
import LoadingAnimation from "../../components/common/LoadingAnimation";
import {setInvalidOptionSchedulesMessage} from "../../actions/join/joinActions";
import ModalPopup from "../../components/common/ModalPopup";
import style from "../../css/join/joinShareStep.less";
import {getNextDeliveryDate} from "../../common/basket";


class JoinSharesOptionsStep extends React.Component {
    getNoItemsMessage = () => {
        return this.props.step === JoinSteps.SHARES ?  translate("_NoShares1")+this.props.farmEmail+translate("_NoShares2") :
            translate("_ContinueNextToCompleteSignupProcess");
    };

    getInvalidOptionScheduleMessage = () => {
        if(this.props.invalidOptionScheduleMessage) {
            return (<ModalPopup
                message={this.props.invalidOptionScheduleMessage}
                middle={{text: 'Close', callback: this.props.setInvalidOptionSchedulesDialog}}/>);
        }
    };

    render() {
        if (this.props.isFetching)
            return <LoadingAnimation/>;
        const items = this.props.items;
        if (items) {
            if (!this.props.isSharesAvailable) {
                return (<div className="no-available-item-message">{translate("_WaitListLabel")}</div>);
            }
            if (Object.keys(items).length > 0) {
                return (<div>
                    {this.props.isWaitListOnly ?
                        <div className="no-available-item-message">{translate("_WaitListLabel")}</div> : undefined
                    }
                    <Row className="join-item-row">
                        {items}
                    </Row>
                    {this.getInvalidOptionScheduleMessage()}
                </div>);
            } else {
                return <div id="notItemMessage"
                            className="no-available-item-message">{this.getNoItemsMessage()}</div>
            }
        }
        else {
            return null;
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    let items = undefined;
    const signupData = (state.signupData || {});
    const summary = (state.summary || {});
    const pickupSite = summary.pickupSite;
    const isWaitListOnly = (signupData.data || {}).isWaitListOnly;
    const sharesData = signupData.sharesData;
    const step = ownProps.step ? ownProps.step : (state.signupData || {}).step;
    if (sharesData){
        items = step === JoinSteps.SHARES ?
            sharesData.shares : sharesData.options;
    }
    let filteredItems;
    let isSharesAvailable = true;
    if(items) {
        if(items.length === 0) {
            isSharesAvailable = false;
        } else {
            let schedules = {};
            if ((ownProps.flow === JoinModes.CHANGE || ownProps.isAddSubscription)) {
                Object.keys(signupData.schedules).map(function (key) {
                    const schedule = signupData.schedules[key];
                    let keepSchedule = true;
                    if(summary.farmStoreClosedEndDate) {
                        const scheduleComingDate = Object.keys(sharesData.remainingScheduleDates || {}).length > 0 &&
                            sharesData.remainingScheduleDates.hasOwnProperty(key)?
                            sharesData.remainingScheduleDates[key][0] : undefined;
                        if (scheduleComingDate <= summary.farmStoreClosedEndDate) {
                            keepSchedule = false;
                        }
                    }
                    if(keepSchedule) {
                        schedules[key] = schedule;
                    }
                }.bind(schedules));
            } else {
                schedules = signupData.schedules;
            }
            const nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
            if (nextDeliveryDates) {
                Object.keys(signupData.schedules).map(function (key) {
                    const schedule = signupData.schedules[key];
                    schedule.nextDeliveryDate = getNextDeliveryDate(pickupSite, undefined, {[schedule.key]: schedule}, nextDeliveryDates);
                });
            }
            const showOnlyFreeOptions = ownProps.flow === JoinModes.CHANGE && state.staticData.allowChangeFreeOptions;

            filteredItems = Object.keys(items).map((key) => {
                let item = items[key];

                if ((!item.waitList || item.isWaitListAllowed) && (!showOnlyFreeOptions || item.price === 0))
                        return (
                            <Col sm={12} md={6} key={key} className="join-item-col">
                                <JoinItemCard item={item} schedules={schedules} isWaitListOnly={isWaitListOnly}/>
                            </Col>
                        );
                }
            );
        }
    }
    return {
        isFetching: isFetching(state, FetchingTypes.LOAD_SIGNUP_SHARES),
        items: filteredItems,
        schedules: signupData.schedules,
        step: step,
        farmEmail: (state.staticData || {}).farmEmail,
        pickupSite: pickupSite,
        isWaitListOnly: isWaitListOnly,
        isSharesAvailable: isSharesAvailable,
        invalidOptionScheduleMessage: signupData.invalidOptionScheduleMessage,
        isAddSubscription: signupData.isAddSubscription
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setInvalidOptionSchedulesDialog: () => {
            dispatch(setInvalidOptionSchedulesMessage(undefined));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)( JoinSharesOptionsStep );


// WEBPACK FOOTER //
// ./src/containers/join/JoinSharesOptionsStep.js